"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVAILABILITY_LABEL = void 0;
const AVAILABILITY_LABEL = exports.AVAILABILITY_LABEL = {
  Available: 'available',
  Error: 'error',
  PreReg: 'pre_reg',
  Premium: 'premium',
  Taken: 'taken'
};